<template lang="html">
    <div class="document">
        <div class="banner-img">
        </div>
        <div class="content">
            <div class="container">
                <div class="title">
                    <p>产品相关文档</p>
                </div>
                <div class="document-tab">
                    <ul>
                        <li v-for="(item,index) in titleList" :key="index">
                            <div  @click="shows=index" >
                                <p :class="{active:shows==(index)}">{{item}}</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="document-content">
                    <div v-show="shows==10"  class="document-video1">
                        <h2>{{hospital}}</h2>
                        <div class="">
                            <video width="100%"
                            :src="videoUrl"
                            controls style="object-fit:cover"
                            poster="https://static.qyjmed.com/webSite/productService/document/video-bg.png">
                            </video>
                        </div>
                    </div>
                    <div v-show="shows==0"  class="document-video">
                        <!-- <video width="100%"
                        src="https://static.qyjmed.com/video/%E7%88%B1%E5%89%AA%E8%BE%91-%E5%85%A8%E5%8C%BB%E4%BD%B3%E8%AE%BE%E5%A4%87%E7%AE%A1%E7%90%86%E7%B3%BB%E7%BB%9F%E8%A7%86%E9%A2%91.mp4"
                        controls style="object-fit:cover"
                        poster="https://static.qyjmed.com/webSite/productService/document/video-bg.png">
                        </video> -->
                        <table border="0" cellpadding="0" cellspacing="0">
                            <thead>
                                <th width="70%">最新更新</th>
                                <th width="10%">操作</th>
                                <th width="20%">最新时间</th>
                            </thead>
                            <tbody>
                                <tr @mouseenter="hot=index" @mouseleave="hot=-1" v-for="(item,index) in videoList" :key='index'>
                                    <td>{{item.name}}</td>
                                    <td>
                                        <a  @click="check(index)">查看</a>
                                    </td>
                                    <td ><p >{{times}}</p></td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <div v-show="shows==1" class="document-browser">
                        <table border="0" cellpadding="0" cellspacing="0">
                            <thead>
                                <th width="70%">最新更新</th>
                                <th width="10%">操作</th>
                                <th width="20%">最新时间</th>
                            </thead>
                            <tbody>
                                <tr @mouseenter="hot=index" @mouseleave="hot=-1" v-for="(item,index) in articleList" :key='index'>
                                    <td>{{item.name}}</td>
                                    <td>
                                        <a  :href="item.url">下载</a>
                                    </td>
                                    <td ><p >{{times}}</p></td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <div v-show="shows==2" class="document-wx">
                        <table border="0" cellpadding="0" cellspacing="0">
                            <thead>
                                <th width="70%">最新更新</th>
                                <th width="10%">操作</th>
                                <th width="20%">最新时间</th>
                            </thead>
                            <tbody>
                                <tr @mouseenter="wx=index" @mouseleave="hot=-1" v-for="(item,index) in wxList" :key='index'>
                                    <td>{{item.name}}</td>
                                    <td>
                                        <a :href="item.url">下载</a>
                                    </td>
                                    <td ><p>{{times}}</p></td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <Foot></Foot>
    </div>
</template>

<script>
import axios from 'axios'
import Foot from '@/components/Footer.vue'
export default {
    name:'document',
    data(){
        return{
            shows: '',
            hot:'0',
            wx:'0',
            videoUrl:'',
            times:'',
            hospital:'',
            titleList:['相关视频','实施方案','软件功能使用说明'],
            videoList:[{
                name:'测试视频1',
                field1:'2019-06-05',
                url:'https://static.qyjmed.com/video/%E8%BF%88%E7%91%9E%E6%89%8B%E6%9C%AF%E5%BA%8A-_%E9%AB%98%E6%B8%85.mp4'
            },{
                name:'测试视频2',
                field1:'2019-06-05',
                url:'https://static.qyjmed.com/video/%E5%BE%B7%E5%B0%94%E6%A0%BC%E5%91%BC%E5%90%B8%E6%9C%BA%E6%93%8D%E4%BD%9C%E6%AD%A5%E9%AA%A4-_%E9%AB%98%E6%B8%85.mp4'
            }],
            articleList:[{
                name:'实施方案1',
                field1:'2019-06-05',
                url:'https://static.qyjmed.com/webSite/productService/document/%E5%85%A8%E5%8C%BB%E4%BD%B3%E8%AE%BE%E5%A4%87%E7%AE%A1%E7%90%86%E8%BD%AF%E4%BB%B6%E4%BB%8B%E7%BB%8D.pptx'
            },{
                name:'实施方案2',
                field1:'2019-06-05',
                url:'https://static.qyjmed.com/webSite/productService/document/%E8%AE%BE%E5%A4%87%E7%AE%A1%E7%90%86%E7%B3%BB%E7%BB%9F%E6%95%B0%E6%8D%AE%E9%87%87%E9%9B%86%E8%A1%A8%E6%A8%A1%E6%9D%BF.xls'
            }],
            wxList:[{
                name:'软件功能使用说明1',
                field1:'2019-06-05',
                url:'https://static.qyjmed.com/webSite/productService/document/%E5%85%A8%E5%8C%BB%E4%BD%B3%E8%AE%BE%E5%A4%87%E7%AE%A1%E7%90%86%E8%BD%AF%E4%BB%B6V2.1.0%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C.docx'
            },{
                name:'软件功能使用说明2',
                field1:'2019-06-05',
                url:'https://static.qyjmed.com/webSite/productService/document/%E5%85%A8%E5%8C%BB%E4%BD%B3%E8%AE%BE%E5%A4%87%E7%AE%A1%E7%90%86%E8%BD%AF%E4%BB%B6V4.0%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C.docx'
            }]
        }
    },
    computed:{
        // times: function(){
        //     return new Date()
        // }
    },
    methods:{
        getTime:function(){
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            if (month < 10) {
                month = "0" + month;
            }
            if (day < 10) {
                day = "0" + day;
            }
            let nowDate = year+'-'+ month  +'-'+ day;
            this.times = nowDate
        },
        getFileVideoList:function(){
            axios.post('/api/oAuth/getFileVideoList').then((res)=>{
                if(res.data.code == 1){
                    this.videoList=res.data.data[0]
                }else{
                    console.log("请登录")
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        getFileOperationList:function(){
            axios.post('/api/oAuth/getFileOperationList').then((res)=>{
                if(res.data.code == 1){
                    this.wxList=res.data.data[0]
                }else{
                    console.log("请登录")
                }

            }).catch(function(err){
                console.log(err)
            })
        },
        getFileImplementationList:function(){
            axios.post('/api/oAuth/getFileImplementationList').then((res)=>{
                if(res.data.code == 1){
                    this.articleList=res.data.data[0]
                }else{
                    console.log("请登录")
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        check:function(index){
            this.shows=10
            this.videoUrl=this.videoList[index].url
            this.hospital=this.videoList[index].name
        }
    },
    mounted(){
        this.getFileVideoList()
        this.getFileOperationList()
        this.getFileImplementationList()
        this.getTime()
    },
    watch:{
        shows:function(newVal,oldVal){
            if(oldVal == 10){
                this.videoUrl=""
            }
        }
    },
    components: {
        Foot
    }
}
</script>

<style lang="scss" scoped>
    .document{
        .banner-img{
            margin-top: $highlight-height;
            height: 140px;
            background: url('https://static.qyjmed.com/webSite/productService/document/bg.png') center;
        }
        .content{
            background: #F0F0F0;
            padding-top: 50px;
            .container{
                background: white;
                .title{
                    p{
                        font-size: 22px;
                        color: #000;
                        padding: 20px 46px;
                        background: #fbfbfb;
                    }
                }
                // 侧边栏
                .document-tab{
                    width: 224px;
                    display: inline-block;
                    vertical-align: top;
                    ul{
                        height: 600px;
                        padding-top: 36px;
                        border-right: 2px solid #f2f2f2;
                        li{
                            width: 224px;
                            // border-bottom: 1px solid #F4F4F4;
                            div{
                                cursor: pointer;
                                p{
                                    font-size: 16px;
                                    color: #838383;
                                    margin: 36px 0 36px 46px;
                                    &.active{
                                        color: #3DA4F7;
                                        border-right: 2px solid;
                                    }
                                }
                            }
                            &:first-child{
                                div{
                                    p{
                                        margin-top: 0;
                                    }
                                }
                            }
                        }
                    }
                }
                // 主内容区
                .document-content{
                    width: 976px;
                    display: inline-block;
                    .document-video1{
                        >h2{
                            padding:30px 136px 0;
                            font-weight: 400;
                            font-size: 22px;

                        }
                        div{
                            padding:30px 136px;
                        }
                    }
                    .document-video,.document-browser,.document-wx{
                        min-height: 600px;
                        margin-top: -60px;
                        table{

                            width: 100%;
                            thead{
                                line-height: 50px;
                                th{
                                    font-size: 20px;
                                    color: #474249;
                                    font-weight: 400;
                                    &:first-child{
                                        text-align: left;
                                        padding-left: 50px;
                                    }
                                }
                            }
                            tbody{
                                margin-top: 10px;
                                tr{
                                    line-height: 68px;
                                    font-size: 18px;
                                    color:#555;
                                    &:nth-child(2n){
                                        background: #FAFAFA;
                                    }
                                    td{
                                        text-align: center;
                                        button{
                                            padding:6px 12px;
                                            border: 0;
                                        }
                                        &:first-child{
                                            text-align: left;
                                            padding-left: 50px;
                                        }
                                        &:nth-child(2){
                                            color: #1F73FF;
                                            cursor: pointer;
                                        }
                                        a:url{
                                            color: #1F73FF;
                                        }
                                        a:visited{
                                            color: #1F73FF;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

            }
        }
    }
</style>
